import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { SVG_COMPONENTS } from '@/assets/admin';

interface DetailsHeaderProps {
  statusLabel: string;
  statusValue: string;
  isArchived: boolean;
  onOpenStatusPicker: () => void;
  onEdit?: () => void;
  onClose: () => void;
  statusButtonRef?: React.RefObject<View>;
  statusButtonId: string;
  statusColorHex: string;
}

export const DetailsHeader: React.FC<DetailsHeaderProps> = ({
  statusLabel,
  statusValue,
  isArchived,
  onOpenStatusPicker,
  onEdit,
  onClose,
  statusButtonRef,
  statusButtonId,
  statusColorHex,
}) => {
  const isCancelled = statusValue === 'cancelled';

  return (
    <View style={styles.container}>
      <View style={styles.left}>
        {isArchived ? (
          <View style={[styles.statusBadge, styles.statusBadgeArchived]}>
            {isCancelled ? (
              <SVG_COMPONENTS.X_CIRCLE width={12} height={12} color={'#F87171'} />
            ) : (
              <View style={[styles.statusDot, { backgroundColor: statusColorHex }]} />
            )}
            <Text style={styles.statusText}>{statusLabel}</Text>
          </View>
        ) : (
          <TouchableOpacity
            ref={statusButtonRef as any}
            testID={statusButtonId}
            style={styles.statusBadge}
            onPress={onOpenStatusPicker}
          >
            {isCancelled ? (
              <SVG_COMPONENTS.X_CIRCLE width={12} height={12} color={'#F87171'} />
            ) : (
              <View style={[styles.statusDot, { backgroundColor: statusColorHex }]} />
            )}
            <Text style={styles.statusText}>{statusLabel}</Text>
            <SVG_COMPONENTS.CHEVRON_DOWN width={10} height={10} color={ADMIN_COLORS.TEXT_SECONDARY} />
          </TouchableOpacity>
        )}

        {!isArchived && (
          <TouchableOpacity style={styles.secondaryButton} onPress={onEdit} disabled={!onEdit}>
            <SVG_COMPONENTS.PENCIL width={14} height={14} color={ADMIN_COLORS.TEXT_SECONDARY} />
            <Text style={styles.secondaryButtonText}>Edit Task</Text>
          </TouchableOpacity>
        )}
        {isArchived && (
          <View style={[styles.secondaryButton, { opacity: 0.6 }]}> 
            <Text style={styles.secondaryButtonText}>Archived</Text>
          </View>
        )}
      </View>
      <TouchableOpacity onPress={onClose}>
        <SVG_COMPONENTS.CANCEL_X width={20} height={20} color={ADMIN_COLORS.TEXT_SECONDARY} />
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: ADMIN_COLORS.BORDER,
  },
  left: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  statusBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 8,
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
  },
  statusBadgeArchived: {
    opacity: 0.9,
  },
  statusDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: ADMIN_COLORS.TEXT_SECONDARY,
  },
  statusText: {
    color: ADMIN_COLORS.TEXT.SECONDARY,
    fontSize: 12,
    textTransform: 'capitalize',
  },
  secondaryButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 8,
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
  },
  secondaryButtonText: {
    color: ADMIN_COLORS.TEXT_SECONDARY,
    fontSize: 12,
    fontWeight: '500',
  },
});


